var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hint-box"},[_c('div',{staticClass:"hint-box__number"},[_vm._v("\n    "+_vm._s(_vm.number)+"\n  ")]),_c('div',{staticClass:"hint-box__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }